const bAccordion = {
    props: {
        active:{
            default: 0
        },
        header:{
            type: String,
            default: "> .b-accordion__head"
        },
        collapsible:{
            type: Boolean,
            default: true
        }
    },
    template:`<div ref="accordion" class="b-accordion stand-alone"><slot></slot></div>`,
    data(){
        return {
            acc: null
        }
    },
    mounted(){
        
        this.acc = jQuery(this.$refs['accordion'])
        this.iniAccordion()

        this.$watch(() => this.active, (newVal, oldVal) => {
            this.setActive(newVal)
        }
        )
    },
    methods:{
        iniAccordion(){
            //console.log(this.active, this.collapsible)
            this.acc.accordion({
                heightStyle: "content",
                collapsible: this.collapsible,
                header: this.header,
                active: this.active,
                create: function (event, ui) {
                },
                beforeActivate: function (event, ui) {
                },
                activate: function (event, ui) {
                }
            })
        },
        setActive(num){
            this.acc.accordion( "option", "active", num );
        },
    }
}